import { render, staticRenderFns } from "./CloseWinners.vue?vue&type=template&id=5e7a63ab"
import script from "./CloseWinners.vue?vue&type=script&lang=js"
export * from "./CloseWinners.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports